import { createEmptyStateResource, StateResource } from '@schir-int-client/ngrx-helpers';
import { TextbausteinId, TextbausteinResource } from './textbaustein.model';
import { getIdNumber } from '../../../../test-helpers/src/lib/resource-helper';

export const textbausteinFeatureState = 'TextbausteinState';

export interface TextbausteinFeatureState {
	textbausteinState: TextbausteinRootState;
}

export interface TextbausteinRootState {
	textbausteinRoot: TextbausteinState;
}

export interface TextbausteinState {
	textbausteine: StateResource<{ [targetColumn: string]: TextbausteinResource[] }>;
}

export const initialState: TextbausteinState = {
	textbausteine: createEmptyStateResource(),
};

export function getById(state: TextbausteinRootState, textbausteinId: TextbausteinId): TextbausteinResource {
	for (const [, textbausteine] of Object.entries(state.textbausteinRoot.textbausteine.resource)) {
		for (const textbausteinResource of textbausteine) {
			if (getIdNumber(textbausteinResource) === textbausteinId) {
				return textbausteinResource;
			}
		}
	}
	return null;
}
